var decode = require('unescape');

const capitalize = name => {
    var capitalized = name.substr(0, 1).toUpperCase() + name.substr(1).toLowerCase();
    return capitalized;
};

const lowercase = name => {
    return name.toLowerCase();
};

const uppercase = name => {
    return name.toUpperCase();
};

const unsecape_html = text => {
    return decode(text)
}

module.exports = {
    capitalize,
    lowercase,
    uppercase,
    unsecape_html
};